var exports = {
  "Nr": "CrosspostCommunityCard.module__card___SzlkMD",
  "Uo": "CrosspostCommunityCard.module__sheetCard___SzlkMD",
  "vK": "CrosspostCommunityCard.module__banner___SzlkMD",
  "_e": "CrosspostCommunityCard.module__bannerImage___SzlkMD",
  "Dw": "CrosspostCommunityCard.module__bannerScrim___SzlkMD",
  "Kk": "CrosspostCommunityCard.module__icon___SzlkMD",
  "rf": "CrosspostCommunityCard.module__body___SzlkMD",
  "$": "CrosspostCommunityCard.module__titleRow___SzlkMD",
  "fh": "CrosspostCommunityCard.module__nameText___SzlkMD",
  "h_": "CrosspostCommunityCard.module__description___SzlkMD",
  "qr": "CrosspostCommunityCard.module__footer___SzlkMD",
  "dJ": "CrosspostCommunityCard.module__stat___SzlkMD",
  "gW": "CrosspostCommunityCard.module__statDot___SzlkMD",
  "rR": "CrosspostCommunityCard.module__statDotOnline___SzlkMD" + " " + "CrosspostCommunityCard.module__statDot___SzlkMD",
  "rb": "CrosspostCommunityCard.module__statDotMembers___SzlkMD" + " " + "CrosspostCommunityCard.module__statDot___SzlkMD",
  "KA": "CrosspostCommunityCard.module__statText___SzlkMD",
  "lm": "CrosspostCommunityCard.module__notice___SzlkMD",
  "XI": "CrosspostCommunityCard.module__action___SzlkMD",
  "Lq": "CrosspostCommunityCard.module__loading___SzlkMD",
};

module.exports = exports;
